import React, { Component } from 'react'
import PropTypes from 'prop-types'
import AppStore from '../../store/AppStore'
import DtoUser from '../../home/dto/DtoUser'
import HomeAction from '../../home/actions/HomeAction'
import { PATH_HOME, PATH_SELECTION } from '../../home/constants/HomeConstants'
import { aquasysPath } from '../../conf/basepath'
import ReactGA from 'react-ga'
import i18n from 'simple-react-i18n'
import ResearchPanel from './research/ResearchPanel'
import { push } from 'react-router-redux'
import { isEqual } from 'lodash'

class DashboardApp extends Component {
	constructor(props) {
		super(props)
		this.state = {
			panel: 'stations',
			error: ''
		}
	}

	componentWillMount() {
		this.putTitle()
	}

	componentWillReceiveProps(nextProps) {
		if (!isEqual(nextProps.isLogged, this.props.isLogged)) {
			this.putTitle(nextProps)
		}
	}

	putTitle = (props = this.props) => {
		if (props.isLogged) {
			AppStore.dispatch(HomeAction.setTitle(i18n.home))
			AppStore.dispatch(HomeAction.setBackPath(PATH_HOME))
		} else {
			AppStore.dispatch(HomeAction.setTitle(undefined))
		}
	}

	openSelectionPage = () => {
		AppStore.dispatch(push(PATH_SELECTION))
	}

	getMySelectionLink = () => {
		if (this.props.isLogged) {
			AppStore.dispatch(push(PATH_SELECTION))
		} else {
			//TO DO
			AppStore.dispatch(HomeAction.updateLoginModalActions([this.openSelectionPage]))
			AppStore.dispatch(HomeAction.updateLoginModalState(true))
		}
	}

	render() {
		ReactGA.set({ userId: this.props.user.login })
		const style = {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			minHeight: 'calc(100vh - 64px)',
			fontFamily: ['Myriad Pro', 'sans-serif']  			
		}
		return (
			<div className='aqua-db-bg' style={ style }>
				<div className='col s12'>
					<div className='row' style={ { marginBottom: '0', marginTop: '30px' } }>
						<div className='col s2 offset-s2 padding-right-20' style={ { width: '15%' } }>
							<img style={ { height: '100px', width: 'auto' } } src={ `${ aquasysPath }/wp-content/uploads/2022/07/logo aQuaDB Def_Plan de travail 1.png` }/>
						</div>	
					</div>
					<div className='row' style={ { marginBottom: '0',textShadow: '0px 2px 5px black' } }>
						<div className='col s2'/>
						<div className='col s7'>
								<h2 className='font-white strong' style={ { fontWeight: 'bold' } }>{ i18n.aquadbTitle }</h2>
						</div>
					</div>
					<div className='row'>
						<ResearchPanel isResearchMap={ false } isLogged={ this.props.isLogged } />
					</div>
					<div className='row' style={ { marginTop: '5px' } }>
						<div className='col s2'/>
						<div className='col s6 font-white valign-wrapper'>
							{ i18n.aquadbDevelopedBy }
							<img className='responsive-img' style={ { maxWidth: '15%', height: 'auto', marginLeft: '0.5em' } } src={ `${ aquasysPath }/wp-content/uploads/2022/07/Logo aQuasys_blanc.svg` }/>
						</div>
						<div className='col s2'/>
					</div>
				</div>
			</div>
		)
	}
}

DashboardApp.propTypes = {
	isLogged: PropTypes.bool,
	login: PropTypes.string,
	user: PropTypes.objectOf(DtoUser)
}

export default DashboardApp



// WEBPACK FOOTER //
// ./src/dashboard/components/DashboardApp.js